<template>
  <div class="center">
    <span>{{ $storeUniversite.labelen.DejaInscrit }}</span>
    <a :href="LienPortail">{{ $storeUniversite.labelen.LienCondidature }}</a>
    <br />
    <span>{{ $storeUniversite.labelen.MotDePasseOublie }}</span>
    <a :href="LienPortail">{{ $storeUniversite.labelen.Portail }}</a>
    <br />
    <span>**********</span>
    <br />
    <span>{{ $storeUniversite.label.DejaInscrit }}</span>
    <a :href="LienPortail">{{ $storeUniversite.label.LienCondidature }}</a>
    <br />
    <span>{{ $storeUniversite.label.MotDePasseOublie }}</span>
    <a :href="LienPortail">{{ $storeUniversite.label.Portail }}</a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //Réafecter objet global
      $storeUniversite: this.$storeUniversite,
      LienPortail: process.env.VUE_APP_LIEN_PORTAIL,
    };
  },
  created() {
    this.LienPortail = process.env.VUE_APP_LIEN_PORTAIL;
  },
};
</script>

<style scoped>
.center {
  border: 2px solid;
  margin: auto;
  width: 50%;
  padding: 10px;
}
</style>
